module.exports = __webpack_public_path__ + "img/menu9.d53a3c48.png";